import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import Translate from 'components/Translate';
import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  component: {
    '& .chk-acceptTerms__span': {
      fontSize: '0.750rem',
      margin: '10px 0 0 0',
      '& span': {
        width: '30px',
        height: '20px',
        '& svg': {
          color: '#000',
          width: '20px',
          height: 'auto'
        }
      }
    }
  }
});

const AcceptTerms: React.FC = React.memo(() => {
  const classes = useStyles({});

  return (
    <div className={classes.component}>
      <div className="chk-acceptTerms__span">
        <Checkbox disabled checked value="checkedE" />
        <Translate term="Concordo que li, e compreendi os" />
        &nbsp;
        <a id="chk-accept-term" href="https://g.eduzz.com/gateway/termosrec" rel="noopener noreferrer" target="_blank">
          <Translate term="termos de assinatura e cancelamento" />
        </a>
      </div>
    </div>
  );
});

export default AcceptTerms;
